import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

const OrderConfEmailFormTemplate = ({ emailAddress }) => {
  return (
    <div>
      {_.isEmpty(emailAddress) ? (
        <p>
          Please keep your order number for your records in case you need to
          contact us about your order.
        </p>
      ) : (
        <p>
          We will send a confirmation email when your order has shipped to the
          email we have on file in the next two to three business days.
        </p>
      )}
    </div>
  );
};

OrderConfEmailFormTemplate.propTypes = {
  emailAddress: PropTypes.string.isRequired,
};

export default connect(state => {
  const email =
    state.userInfo.customer && state.userInfo.customer.emailAddress
      ? state.userInfo.customer.emailAddress
      : '';
  return {
    emailAddress: email,
  };
})(OrderConfEmailFormTemplate);



// WEBPACK FOOTER //
// ./src/components/Forms/OrderConfEmailForm.jsx